import { SVG_GetUniqueID } from "./SVG_GetUniqueID";
import { SVG_AddSlice } from "./SVG_AddSlice";
import { NS_SVG } from "../constants";

export function SVG_DrawSlices(originX, originY, radius, pieSections, svgElement) {
  var startAngle = 0;
  for (var sliceIdx in pieSections) {
    var currentSlice = pieSections[sliceIdx];
    var curPath = document.createElementNS(NS_SVG, "path");
    var idStr = SVG_GetUniqueID("path");
    curPath.setAttribute("id", idStr);
    curPath.setAttribute("fill", currentSlice["color"]);
    var delta = 2 * Math.PI * (currentSlice["percent"] / 100);
    var endAngle = startAngle + delta;
    curPath.setAttribute("d", SVG_AddSlice(startAngle, endAngle, radius, originX, originY));
    svgElement.appendChild(curPath);
    startAngle = endAngle;
  }
}
